import { createDefaultHeaders } from '@/api';
import { getSession, urlWithAdminQuery } from '@/auth';

export type RmProperty = { PropertyID: number; Name: string; ShortName: string };
export type RmUnit = { UnitID: number; Name: string; PropertyID: number };
export type RmChargeType = { ChargeTypeID: number; Name: string };

export type RmChargePayload = {
  Amount: number;
  PropertyID: number;
  UnitID: number;
  ChargeTypeID: number;
  TransactionDate: string;
  Comment: string;
  Reference: string;
};

export const listRmProperties = async (): Promise<RmProperty[]> => {
  const session = await getSession();
  const resp = await fetch(urlWithAdminQuery('/pms/properties', session.adminEmail), {
    method: 'GET',
    headers: createDefaultHeaders({ authToken: session.idToken.toString() }),
  });
  if (!resp.ok) {
    const errorText = await resp.text().catch(() => 'Unknown error');
    throw new Error(errorText);
  }
  return resp.json();
};

export const listRmUnits = async (propertyId: number): Promise<RmUnit[]> => {
  const session = await getSession();
  const resp = await fetch(
    urlWithAdminQuery(`/pms/properties/${propertyId}/units`, session.adminEmail),
    {
      method: 'GET',
      headers: createDefaultHeaders({ authToken: session.idToken.toString() }),
    },
  );
  if (!resp.ok) {
    const errorText = await resp.text().catch(() => 'Unknown error');
    throw new Error(errorText);
  }
  return resp.json();
};

export const listRmChargeTypes = async (): Promise<RmChargeType[]> => {
  const session = await getSession();
  const resp = await fetch(urlWithAdminQuery('/pms/charge-types', session.adminEmail), {
    method: 'GET',
    headers: createDefaultHeaders({ authToken: session.idToken.toString() }),
  });
  if (!resp.ok) {
    const errorText = await resp.text().catch(() => 'Unknown error');
    throw new Error(errorText);
  }
  return resp.json();
};

export const uploadChargesToRm = async (
  billingId: string,
  charges: RmChargePayload[],
): Promise<unknown> => {
  const session = await getSession();
  const resp = await fetch(urlWithAdminQuery('/pms/charges', session.adminEmail), {
    method: 'POST',
    headers: createDefaultHeaders({ authToken: session.idToken.toString() }),
    body: JSON.stringify({ billing_id: billingId, charges }),
  });
  if (!resp.ok) {
    const errorText = await resp.text().catch(() => 'Unknown error');
    throw new Error(errorText);
  }
  return resp.json();
};
